import './login.scss';

import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Logo from '@/media/logo.svg?react';
import { Button } from '@/shared/ui';
import { useAppDispatch } from '@/store';
import { setHeaderConfig } from '@/store/app.slice';

import { LoginFields } from './entities';
import useLogin from './hooks/useLogin';
import type { IFormInput } from './types/form-types';

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const methods = useForm<IFormInput>({
    mode: 'all',
    delayError: 200,
    defaultValues: { email: '', password: '', isRemember: false, dealer: '' }
  });
  const {
    formState: { errors }
  } = methods;

  const { isLoading, handleLogin } = useLogin();

  useEffect(() => {
    dispatch(
      setHeaderConfig({
        helmetTitle: 'Авторизация'
      })
    );
    return () => {
      dispatch(setHeaderConfig({}));
    };
  }, []);

  return (
    <div className="login">
      <div className="login__wrapper">
        <div className="login__content">
          <div className="login__logo">
            <Logo />
          </div>
          <div className="login__title">Вход в систему</div>
          <FormProvider {...methods}>
            <form
              className="login__form"
              onSubmit={methods.handleSubmit(handleLogin)}
            >
              <LoginFields />

              <Button
                type="submit"
                className="login__submit"
                variant="filled-blue"
                disabled={Object.values(errors).length !== 0}
                isLoading={isLoading}
              >
                Войти
              </Button>
            </form>
          </FormProvider>
        </div>

        <div className="login__rights">
          © {new Date().getFullYear()} TechDrive All rights reserved
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
